import api from '../../services/api';
import { translate, getCurrentLanguageCode } from '../../utils/translation';

// initial state
const state = {
  stores: [],
  loading: false,
  error: null
};

// getters
const getters = {
  getStoreById: state => id => {
    return state.stores.find(store => store.id === id);
  },

  getCountries: state => {
    const countries = state.stores.reduce((acc, store) => {
      if (!acc.some(c => c.id === store.country_id)) {
        acc.push({
          id: store.country_id,
          name: store.country
        });
      }
      return acc;
    }, []);

    return countries.sort((a, b) => a.name.localeCompare(b.name));
  },

  getStoresByCountry: state => countryId => {
    return state.stores.filter(store => store.country_id === countryId);
  }
};

// actions
const actions = {
  async fetchStoreLocations({ commit }) {
    commit('setLoading', true);
    try {
      const response = await api.getStores(getCurrentLanguageCode());
      commit('setStores', response.data);
    } catch (error) {
      commit('setError', error.message);
    } finally {
      commit('setLoading', false);
    }
  },

  clearError({ commit }) {
    commit('setError', null);
  }
};

// mutations
const mutations = {
  setStores(state, stores) {
    state.stores = stores;
  },

  setLoading(state, status) {
    state.loading = status;
  },

  setError(state, error) {
    state.error = error;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};